import { DirectiveOptions } from 'vue';

import { isInViewport } from '@/shared/filters/utils-filter';

let addEvent = () => {};
const directive: DirectiveOptions = {
    bind(el, binding, node) {
        addEvent = () => {
            if(binding){
                binding.value.event(isInViewport(el.children[el.children.length - 1]));
            }
        }

        if (window.innerWidth > binding.value.maxWindowSize) {
            document.addEventListener('scroll', addEvent);
        }
    },
    unbind(el, binding, node) {
        document.removeEventListener('scroll', addEvent);
    }
};

export default directive;